import moment from 'moment'
import React from 'react'
import { Table } from 'reactstrap'

const NeedTabPanel = ({
  TabPanel,
  value,
  postNeedHeaderArr,
  HtmlTooltip,
  postNeedDataList,
  styles,
  EditIcon,
  setCommentModal,
  setEditComment,
  UpArrowIcon,
  setAccordionFunction,
  DownArrowBlueIcon,
  setTimmerLoader,
  accordionOpenIndex,
  TdCollapseSectionInner,
  setNeedAccordionInsideFunction,
  needAccordionInsideOpenIndex,
  orderType,
  needPageCount,
  Pagination,
  needPage,
  handleNeedPageChange,
  information,
  stateConvert,
  loader,
  Timmer,
  timmerLoader,
  loaderVisible,

}) => (
  <TabPanel value={value} index={0}>
    <Table responsive>
      <thead>
        <tr>
          {postNeedHeaderArr && postNeedHeaderArr.map((items, index) => (
            <>{index === 1 || index === 5 || index === 8 ?
              <th key={index} style={{ "white-space": "normal", "min-width": "112px", "max-width": "112px" }}>{items.title}</th> :
              index === 6 ? <th key={index}>{items.title}

                <HtmlTooltip
                  placement="right"
                  enterTouchDelay={0}
                  arrow
                  title={<><p><b>No Action:</b> This status applies when a bid has been received, but no action has been taken, and the requested date is in the past.</p>
                    <p><b>Active:</b> The "Active" status pertains to a post that is currently active on the marketplace. It includes scenarios where no bids have been received, as well as cases
                      where bids have been received, and the requested delivery/pickup dates are in the future. For offers, the determination should be based on the receipt of offers and the dates for requested delivery/pickup in the future.</p>

                    <p><b>Expired:</b> The "Expired" status is assigned when no bids have been received, and the post has reached its expiration date or when a bid has timed out.</p>
                    <p><b>Order Created :</b> If order is created on the post.</p></>}
                >
                  <img style={{ paddingLeft: "5px", position: "relative", top: "-1px", cursor: "pointer" }} src={information} alt="Iicon" />
                </HtmlTooltip>
              </th> :
                index === 7 ? <th key={index}>{items.title}
                  <HtmlTooltip
                    placement="right"
                    enterTouchDelay={0}
                    arrow
                    // classes={tooltipClass}
                    title={<><p><b>Pending:</b> When a bid has been received, this status indicates that a decision is pending. If a bid is accepted, it should appear in the dropdown menu, including relevant details such as the target price and other specifications outlined in the design.</p>
                      {/* <p><b>Timed Out:</b> In cases where a bid is received but the decision process takes too long, resulting in a timeout.</p> */}

                      <p><b>Bid Declined:</b> When a bid has been received but is subsequently declined.</p>
                      <p><b>Accepted:</b> Upon receiving a bid, if it is accepted, an order is created successfully.</p></>}
                  >
                    <img style={{ paddingLeft: "5px", position: "relative", top: "-1px", cursor: "pointer" }} src={information} alt="Iicon" />
                  </HtmlTooltip>
                </th> : <th key={index}>{items.title}</th>}</>
          ))}
        </tr>
      </thead>
      <tbody className='post-tab-table-tbody'>
        {
          postNeedDataList && postNeedDataList?.length !== 0 ? postNeedDataList.map((items, index) => (
            <> 
            {/** Post Details Row**/}
              <tr className={styles.homeWrapper} key={`${items.postId}-${index}`}>
                <td title={items?.postName}>
                  {items?.postName?.substring(0, 10)}
                  {items?.postName?.length > 10 && <span>...</span>}
                </td>
                <td>{items?.postDetails?.private ? 'Yes' : 'No'}</td>
                <td>{items?.posterDetails?.email}</td>
                {/* <td>{items?.posterDetails?.companyName} - {items?.posterDetails?.address?.city + ", " + (items?.posterDetails?.address?.stateAbv ? items?.posterDetails?.address?.stateAbv : stateConvert(items?.posterDetails?.address?.state))}</td> */}
                <td>{items?.postDetails?.shippingAddress?.locationName} - {items?.postDetails?.shippingAddress?.city + ", " + (items?.postDetails?.shippingAddress?.stateAbv ? items?.postDetails?.shippingAddress?.stateAbv : stateConvert(items?.postDetails?.shippingAddress?.state))}</td>
                <td>{moment(items?.postDetails?.requestDeliveryDate.split('T')[0]).format("MM/DD/YYYY")}</td>
                <td>{items?.noOfBidsAndOffers}</td>
                <td>{items?.postStatus}</td>
                <td>{items?.postBidOrOfferStatus}</td>
                <td style={loader ? { display: 'none' } : { display: 'block' }}>
                  {items?.postStatus === "ACTIVE" ? <Timmer key={`timer_${items.postId}`} time={items?.postTimeLeft - Math.trunc(Date.now() / 1000)} /> : "00:00:00"}
                </td>
                <td style={loader ? { display: 'block' } : { display: 'none' }}></td>
                <td style={{ "cursor": "pointer" }} title={items?.accountRepresentative && items?.accountRepresentative.length !== 0 ? items?.accountRepresentative.join(', ') : ''}>
                  {items?.accountRepresentative && items?.accountRepresentative.length !== 0 ? items?.accountRepresentative.join(', ').substring(0, 15) : "NA"}
                  {items?.accountRepresentative && items?.accountRepresentative.length !== 0 ? items?.accountRepresentative.join(', ')?.length > 15 && <span>...</span> : ""}
                </td>
                <td title={items?.adminComments && items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg}>
                  <span style={{ marginRight: "8px" }} onClick={() => {
                    setCommentModal(true)
                    setEditComment(items)
                  }}><EditIcon /></span>
                  {items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg?.substring(0, 3)}
                  {items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg?.length > 3 && <span>...</span>}
                </td>
                <td className='expand-collapse-class'>
                  <div >
                    {(accordionOpenIndex === index) ?
                      <UpArrowIcon onClick={() => {
                        setAccordionFunction()
                      }} />
                      :
                      <DownArrowBlueIcon onClick={() => {
                        setTimmerLoader(true)
                        const interval = setInterval(() => {
                          setTimmerLoader(false)
                          clearInterval(interval)
                        }, 1000);
                        setAccordionFunction(index)
                      }} />
                    }
                  </div>
                </td>
              </tr>

              {/** Post Bid Details Row**/}      
              {accordionOpenIndex === index &&
                <>{items?.postStatus !== "ORDER CREATED" ?
                  items?.postBidOrOfferInfo && items?.postBidOrOfferInfo.map((bidItems, index) => (
                    <>
                      <tr className='order-details-wrapper'>
                        <td colspan="1">
                          <div>
                            <p></p>
                          </div>
                        </td>

                        <td colspan="1"></td>
                        <td colspan="1">
                          <div>
                            <p>{bidItems?.bidderEmail}</p>
                          </div>
                        </td>
                        <td colspan="1">
                          <div>
                          <p>{bidItems?.bidderCompanyName}</p>
                          </div>
                        </td>
                        <td colspan="1">
                          <div>
                            <p>{bidItems?.bidderPhoneNumber ? bidItems?.bidderPhoneNumber : "NA"}</p>
                          </div>
                        </td>
                        <td colspan="1"></td>
                        <td colspan="1"></td>
                        <td colspan="1">
                          <div>
                            <p>{bidItems?.bidStatus}</p>
                          </div>
                        </td>
                        <td colspan="1"></td>

                        <td colspan="1" style={{ "cursor": "pointer" }} title={bidItems?.bidderAccountRepresentative && bidItems?.bidderAccountRepresentative.length !== 0 ? bidItems?.bidderAccountRepresentative.join(', ') : ''}>
                          {bidItems?.bidderAccountRepresentative && bidItems?.bidderAccountRepresentative.length !== 0 ? bidItems?.bidderAccountRepresentative.join(', ').substring(0, 15) : "NA"}
                          {bidItems?.bidderAccountRepresentative && bidItems?.bidderAccountRepresentative.length !== 0 ? bidItems?.bidderAccountRepresentative.join(', ')?.length > 15 && <span>...</span> : ""}
                        </td>
                        <td title={bidItems?.bidComment && bidItems?.bidComment}>
                          {bidItems?.bidComment && bidItems?.bidComment?.substring(0, 15)}
                          {bidItems?.bidComment && bidItems?.bidComment?.length > 15 && <span>...</span>}
                        </td>
                        <td colspan="1">
                        </td>


                        <td colspan="1"></td>
                      </tr>
                      {needAccordionInsideOpenIndex === index &&
                        <>
                          <tr className='order-details-wrapper' style={{ background: "#ECECEC" }}>
                            <td colspan="1"></td>
                            <td colspan="1"></td>
                            <td colspan="1"></td>
                            <td colspan="2"></td>
                            <td colspan="1"></td>
                            <td colspan="1"></td>
                            <td colspan="1"></td>
                            <td colspan="1"></td>
                            <td colspan="1"> </td>
                            <td colspan="1"></td>
                            <td colspan="1"></td>
                            <td colspan="1"></td>
                          </tr>
                        </>
                      }
                    </>)) :
                  <>
                    <tr className='order-details-wrapper'>
                      <td colspan="1">
                        <div>
                          <p></p>
                        </div>
                      </td>

                      <td colspan="1"></td>
                      <td colspan="1">
                        <div>
                          <p>{items?.postBidOrOfferInfo[0]?.bidderEmail}</p>
                        </div>
                      </td>
                      <td colspan="1">
                        <div>
                          {items?.postBidOrOfferInfo[0]?.bidStatus === "Bid Accepted" || items?.postBidOrOfferInfo[0]?.bidStatus === "Alt Bid Accepted" || items?.postBidOrOfferInfo[0]?.bidStatus === "Bid Received" || items?.postBidOrOfferInfo[0]?.bidStatus === "Alt Bid Received" ?
                            <TdCollapseSectionInner>
                              <p>{items?.postBidOrOfferInfo[0]?.bidderCompanyName}</p>
                              <div className='expand-collapse-class-inside'>
                                {(needAccordionInsideOpenIndex === index) ?
                                  <h4 onClick={() => setNeedAccordionInsideFunction()}><i></i></h4>
                                  :
                                  <h5 onClick={() => setNeedAccordionInsideFunction(index)}><i></i></h5>
                                }
                              </div>
                            </TdCollapseSectionInner> :
                            <p>{items?.postBidOrOfferInfo[0]?.bidderCompanyName}</p>}
                        </div>
                      </td>
                      <td colspan="1">
                        <div>
                          <p>{items?.postBidOrOfferInfo[0]?.bidderPhoneNumber ? items?.postBidOrOfferInfo[0]?.bidderPhoneNumber : "NA"}</p>
                        </div>
                      </td>
                      <td colspan="1"></td>
                      <td colspan="1"></td>
                      <td colspan="1">
                        <div>
                          <p>{items?.postBidOrOfferInfo[0]?.bidStatus}</p>
                        </div>
                      </td>
                      <td colspan="1"></td>
                      <td colspan="1" style={{ "cursor": "pointer" }} title={items?.postBidOrOfferInfo?.bidderAccountRepresentative && items?.postBidOrOfferInfo?.bidderAccountRepresentative.length !== 0 ? items?.postBidOrOfferInfo?.bidderAccountRepresentative.join(', ') : ''}>
                        {items?.postBidOrOfferInfo?.bidderAccountRepresentative && items?.postBidOrOfferInfo?.bidderAccountRepresentative.length !== 0 ? items?.postBidOrOfferInfo?.bidderAccountRepresentative.join(', ').substring(0, 15) : "NA"}
                        {items?.postBidOrOfferInfo?.bidderAccountRepresentative && items?.postBidOrOfferInfo?.bidderAccountRepresentative.length !== 0 ? items?.postBidOrOfferInfo?.bidderAccountRepresentative.join(', ')?.length > 15 && <span>...</span> : ""}
                      </td>
                      <td title={items?.postBidOrOfferInfo[0]?.bidComment && items?.postBidOrOfferInfo[0]?.bidComment}>
                        {items?.postBidOrOfferInfo[0]?.bidComment && items?.postBidOrOfferInfo[0]?.bidComment?.substring(0, 15)}
                        {items?.postBidOrOfferInfo[0]?.bidComment && items?.postBidOrOfferInfo[0]?.bidComment?.length > 15 && <span>...</span>}
                      </td>
                      <td colspan="1">
                      </td>


                      <td colspan="1"></td>
                    </tr>
                    {needAccordionInsideOpenIndex === index &&
                      <>
                        <tr className='order-details-wrapper' style={{ background: "#ECECEC" }}>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="3">
                            <div style={{ maxWidth: "300px" }}>
                              <p>{orderType(items?.postDetails, items?.postBidOrOfferInfo[0].quantity)} - {items?.postBidOrOfferInfo[0]?.bidStatus} @ ${items?.postBidOrOfferInfo[0]?.bidPrice} for {items?.postBidOrOfferInfo[0]?.pickup ? "Pickup from" : "Delivery to"} {items?.postBidOrOfferInfo[0]?.shippingAddress?.locationName}, {items?.postBidOrOfferInfo[0]?.shippingAddress?.address1}, {items?.postBidOrOfferInfo[0]?.shippingAddress?.address2 ? items.postBidOrOfferInfo[0].shippingAddress.address2 + "," : ""} {items?.postBidOrOfferInfo[0]?.shippingAddress?.city} {items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv ? items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv : stateConvert(items?.postBidOrOfferInfo[0]?.shippingAddress?.state)}{(items?.postBidOrOfferInfo[0]?.shippingAddress?.zipCode) ? ", " + items.postBidOrOfferInfo[0].shippingAddress.zipCode : ""} on {moment(items?.postBidOrOfferInfo[0]?.bidDate.split('T')[0]).format("MM/DD/YYYY")}</p>
                            </div>

                          </td>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="1"> </td>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                        </tr>
                      </>
                    }
                  </>}</>
              }
            </>
          )) :
            <>{!loaderVisible && !loader ? <tr className={styles.homeWrapper}>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><p>No Record found</p></td>
            </tr> :
              <tr className={styles.homeWrapper}></tr>}
            </>
        }
      </tbody>
    </Table>

    {needPageCount && postNeedDataList && postNeedDataList?.length !== 0 ? <Pagination count={needPageCount}
      page={needPage}
      onChange={handleNeedPageChange} /> : ""}

  </TabPanel>
)

export default NeedTabPanel